// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SchoolWishList/OperationBtn2.less
// module id = 1624
// module chunks = 0